import AuthPageWrapper from './auth-page-warapper';
import PageWrapper from './custom-page-wrapper';

const CustomPage = {
    Wrapper: PageWrapper,
    AuthWrapper: AuthPageWrapper,

    name: 'custom page',
};

export default CustomPage;
